import { render, staticRenderFns } from "./TheGeneralCodeEditForm.vue?vue&type=template&id=70f0406c&"
import script from "./TheGeneralCodeEditForm.vue?vue&type=script&lang=js&"
export * from "./TheGeneralCodeEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports